// @ts-nocheck
import siteMessage from "@insite/client-framework/SiteMessage";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import DataViewLoadingOverlay from "@store/Library/Components/Toolkit/DataViewLoadingOverlay";
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import OrderLayout from "@store/Library/Components/Toolkit/Layout/OrderLayout";
import { LoadingOverlayProps } from "@store/MobiusOverrides/LoadingOverlay/LoadingOverlay";
import useQueryString from "@toolkit/Framework/Common/Hooks/useQueryString";
import { useWishListState } from "@toolkit/Framework/Store/Data/MyLists/MyListsHooks";
import React, { FC } from "react";

export interface StaticListStaticListPageContainerStyles {
    loadingOverlay?: LoadingOverlayProps;
    errorInfosBox?: InfosBoxProps;
}

export const staticListStaticListPageContainerStyles: StaticListStaticListPageContainerStyles = {
    errorInfosBox: { type: "error" },
};

type Props = WidgetProps;

const styles = staticListStaticListPageContainerStyles;

const StaticListPageContainer: FC<Props> = ({ id: widgetId }) => {
    const { id } = useQueryString();
    const wishListDataView = useWishListState(id);

    return (
        <DataViewLoadingOverlay dataView={wishListDataView} {...styles.loadingOverlay}>
            {wishListDataView.errorStatusCode === 404 ? (
                <InfosBox {...styles.errorInfosBox}>{siteMessage("Lists_List_NotFound")}</InfosBox>
            ) : (
                <OrderLayout id={widgetId} />
            )}
        </DataViewLoadingOverlay>
    );
};

const widgetModule: WidgetModule = {
    component: StaticListPageContainer,
    definition: {
        group: "Static List",
        displayName: "Page Container",
        allowedContexts: ["StaticListPage"],
    },
};
export default widgetModule;
